export default __webpack_public_path__ + "static/media/Menubar.bb7d63e5.svg";